export var storage;
(function (storage) {
    function get(key, def = () => null) {
        let r = localStorage.getItem(key);
        if (r == null)
            return def();
        return JSON.parse(r);
    }
    storage.get = get;
    function set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    storage.set = set;
    class Variable {
        constructor(key, initial) {
            this.key = key;
            this.value = null;
            this.value = get(key, initial);
        }
        get() {
            return this.value;
        }
        set(value) {
            this.value = value;
            set(this.key, value);
        }
        map(f) {
            let old = this.get();
            let n = f(this.get());
            if (n == undefined)
                n = old; // Assume f changed the value in place instead of constructing a new one
            this.set(n);
        }
        save() {
            set(this.key, this.value);
        }
    }
    storage.Variable = Variable;
})(storage || (storage = {}));
